import RolesOverview from '@/views/admin/roles/RolesOverview.vue';

export default {
  path: 'roles',
  name: 'RolesOverview',
  component: RolesOverview,
  meta: { menuItemName: 'RolesOverview' }
};
